import eventBus from '/src/utils/event-bus'
import StoreService from '/src/services/store'
import { EVENTS, KEYS } from '/src/utils/constants'

export function beforeRoute(url) {
    const pathname = url.pathname
    eventBus.trigger(EVENTS.UI.UPDATE_NAV, {
        pathname: pathname
    })
}

export function fetchComboboxRisorse() {
    return StoreService.fetchComboboxData({
        storageKey: 'comboboxRisorse',
        storeMethod: StoreService.fetchRisorse.bind(StoreService),
        formatFn: r => ({ value: r.id, label: r.nickname })
    });
}

export function fetchComboboxStati() {
    return StoreService.fetchComboboxData({
        storageKey: 'comboboxStati',
        storeMethod: StoreService.fetchStati.bind(StoreService),
        formatFn: s => ({ value: s.id, label: s.label })
    });
}

export function fetchComboboxStatiTask() {
    return StoreService.fetchComboboxData({
        storageKey: 'comboboxStatiTask',
        storeMethod: StoreService.fetchStatiTask.bind(StoreService),
        formatFn: s => ({ value: s.id, label: s.label })
    });
}

export function fetchComboboxSocieta() {
    return StoreService.fetchComboboxData({
        storageKey: 'comboboxSocieta',
        storeMethod: StoreService.fetchSocieta.bind(StoreService),
        formatFn: s => ({ value: s.id, label: s.label })
    });
}

export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function getLogo(societa) {
    let logo = "";
    switch (societa) {
        case "NSG srl":
            logo = "/images/nsg.png"
            break;
        case "Noknok srl":
            logo = "/images/noknok.png"
            break;
    }
    return logo;
}

export function getIdRisorsa() {
    const utente = StoreService.getUser();
    return utente["ID_Risorsa"];
}